import { useSettings } from "@/context/SettingsContext";
import { WEIGHT_UNITS } from "@/lib/api";

export default function UnitToggle({ testid = "unit-toggle" }) {
  const { unit, setUnit } = useSettings();
  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <span className="label-eyebrow">Visualizar por</span>
      <div className="flex border" style={{ borderColor: "var(--border-default)" }}>
        {WEIGHT_UNITS.map((u) => {
          const active = unit === u.value;
          return (
            <button
              key={u.value}
              onClick={() => setUnit(u.value)}
              data-testid={`unit-${u.value}`}
              className="px-3 py-1.5 text-xs uppercase tracking-wider transition-colors border-l first:border-l-0"
              style={{
                borderColor: "var(--border-default)",
                background: active ? "var(--gold)" : "transparent",
                color: active ? "#ffffff" : "var(--text-secondary)",
              }}
            >
              {u.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
